<template>
    <div>
        <el-tabs v-model="tabName" @tab-click="drawCharts">
            <el-tab-pane label="扫码趋势分析" name="dateTab">
            </el-tab-pane>
            <el-tab-pane label="扫码时段分析" name="timeTab">
            </el-tab-pane>
            <el-tab-pane label="扫码地域分析" name="locationTab">
            </el-tab-pane>
        </el-tabs>
        <div style="display: flex;justify-content: center">
            <div class="analysisChart" style="width: 1000px;height:400px;" ref="analysisChart"></div>
        </div>
        <div>
            <div>
                <div style="display: flex;justify-content: flex-start">
                    <el-input placeholder="码流水号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initScanRecords"
                              style="width: 150px" v-model="searchValue.codeSerialNumber"
                              @keydown.enter.native="initScanRecords"></el-input>
                    <el-input placeholder="IP地址" prefix-icon="el-icon-search"
                              clearable
                              @clear="initScanRecords"
                              style="width: 150px;margin-left: 20px" v-model="searchValue.scanIp"
                              @keydown.enter.native="initScanRecords"></el-input>
                    <el-date-picker
                            v-model="searchValue.scanDate"
                            type="date"
                            style="margin-left: 20px"
                            value-format="yyyyMMdd"
                            placeholder="扫码日期">
                    </el-date-picker>
                    <el-button icon="el-icon-search" type="primary" @click="initScanRecords"
                               style="margin-left: 10px">
                        搜索
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    ref="scanRecordTable"
                    :data="scanRecords"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
                <el-table-column
                        prop="scanRecordId"
                        align="center"
                        label="扫码编号"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="codeSerialNumber"
                        label="码流水号"
                        align="center"
                        min-width="20%">
                </el-table-column>
                <el-table-column
                        prop="scanDateTime"
                        label="扫码时间"
                        :formatter="formatScanDateTime"
                        min-width="15%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="scanIp"
                        label="扫码IP"
                        align="center"
                        min-width="15%">
                </el-table-column>
                <el-table-column
                        prop="scanProvince"
                        label="扫码省份"
                        min-width="20%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="scanCity"
                        label="扫码城市"
                        min-width="20%"
                        align="center">
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "QRMStatistic",
        inject: ['reload'],
        data() {
            return {
                tabName: 'dateTab',
                dateData: [],
                dateXData: [],
                dateYData: [],
                searchValue: {
                    codeSerialNumber: null,
                    scanIp: null,
                    scanDate: null,
                },
                scanRecords: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
            };
        },
        mounted() {
            this.drawCharts();
            this.initScanRecords();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initScanRecords();//获取列表数据
                }
            }
        },
        methods: {
            initScanRecords() {
                this.loading = true;
                let url = '/qrm/statistic/statisticByDetail?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.codeSerialNumber) {
                    url += '&codeSerialNumber=' + this.searchValue.codeSerialNumber;
                }
                if (this.searchValue.scanIp) {
                    url += '&scanIp=' + this.searchValue.scanIp;
                }
                if (this.searchValue.scanDate) {
                    url += '&scanDate=' + this.searchValue.scanDate;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.scanRecords = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initScanRecords();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initScanRecords();
            },
            drawCharts() {
                var url = '';
                if(this.tabName == 'dateTab' || this.tabName == undefined || this.tabName == ''){
                    url = '/qrm/statistic/statisticByDate';
                }else if(this.tabName == 'timeTab'){
                    url = '/qrm/statistic/statisticByTime';
                }else if(this.tabName == 'locationTab'){
                    url = '/qrm/statistic/statisticByLocation';
                }
                let analysisChart = this.$echarts.init(this.$refs.analysisChart);
                let param = {};
                this.getRequest(url, param).then(resp => {
                    if (resp) {
                        this.dateData = resp.obj.dataList;
                        this.dateXData = resp.obj.xdataList;
                        this.dateYData = resp.obj.ydataList;
                        // 绘制图表
                        analysisChart.setOption({
                            title: {
                                text: "",
                                left: "5%"
                            },
                            tooltip: { trigger: "axis" },
                            legend: {
                                data: ["扫码次数"],
                                right: "5%"
                            },
                            grid: {
                                left: "5%",
                                right: "6%",
                                bottom: "10%",
                                containLabel: true
                            },
                            xAxis: {
                                type: "category",
                                boundaryGap: true,
                                data: this.dateXData,
                                // axisLine: { lineStyle: { color: "#999", width: 0.1 } },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#999",
                                        width: 0.1
                                    }
                                }
                            },
                            yAxis: {
                                type: "value",
                                // axisLine: { lineStyle: { color: "#999", width: 0.1 } }
                            },
                            series: [
                                {
                                    type: "bar",
                                    name: "访问次数",
                                    barWidth: '10%',
                                    data: this.dateYData,
                                    areaStyle: {
                                        color: "rgb(220,247,245)"
                                    },
                                    smooth: true,
                                    itemStyle: {
                                        normal: {
                                            color: "#43c4fd"
                                        }
                                    }
                                }
                            ]
                        });
                    }
                });
            },
            formatScanDateTime(row, column) {
                // 获取单元格数据
                let time = row.scanDateTime;
                if(time == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                let date = new Date(time.replace(pattern, '$1-$2-$3 $4:$5:$6'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                return Y+M+D+h+m+s;
            },
        }
    }
</script>

<style>

</style>